import { tsValidateArray, tsValidateNumber, tsValidateResult, tsValidateString, tsValidateValue, tsValidator_nonMandatoryString } from '@nu-art/ts-common';
import { itemTypeValues } from './types.js';
import { knowledgeManagerDBGroup } from '../common.js';
const Validator_Structure = () => {
    return (input) => {
        return tsValidateResult(input, {
            name: tsValidateString(),
            itemsType: tsValidateValue([...itemTypeValues], false),
            items: tsValidateArray(Validator_Structure(), false)
        });
    };
};
const Validator_ModifiableProps = {
    name: tsValidateString(),
    edition: tsValidator_nonMandatoryString,
    year: tsValidateNumber(),
    isbn: tsValidateString(),
    eisbn: tsValidator_nonMandatoryString,
    itemsType: tsValidateValue([...itemTypeValues], false),
    // TODO: add a recursive validation for items
    items: tsValidateArray(Validator_Structure(), false),
};
const Validator_GeneratedProps = {
// 
};
export const DBDef_Book = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'books',
    entityName: 'Book',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'book'
    },
    backend: {
        name: 'books'
    },
};
//# sourceMappingURL=db-def.js.map